import LazyLoad from "vanilla-lazyload";

custom.lazyImages = (() => {
  let lazyLoadInstance;

  function init() {
    lazyLoadInstance = new LazyLoad({
      // Your custom settings go here
      elements_selector: '.lazyload',
      threshold: 500
    });
  }

  function reinit() {
    lazyLoadInstance.update();
  }

  return {
    reinit,
    init
  }
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/lazy-images.js